// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles live with CreateGeneralMessageView.css so V2 settings, content and preview share one design surface. */
`, "",{"version":3,"sources":["webpack://./src/components/GeneralMessageContentV2/GeneralMessageContentV2.css"],"names":[],"mappings":"AAAA,gHAAgH","sourcesContent":["/* Styles live with CreateGeneralMessageView.css so V2 settings, content and preview share one design surface. */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
